import http, { API_CORE } from '../http';

export default function AiUsagesService() {
  const getAiUsages = async () => {
    const response = await http(API_CORE).get('/ai-usages');
    return response.data;
  };

  return {
    getAiUsages: getAiUsages,
  };
}
